import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Image,
  Spacer,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack,
  Collapse,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { Link, useNavigate } from "react-router-dom";

import LogoHustle from "../assets/images/Hustle.png";

export default function NavbarLanding() {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const navigate = useNavigate();

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth" });
  };

  const textColor = useColorModeValue("white", "brand.500");

  return (
    <Box px={6} py={4} bg="transparent" position="static" top={0} zIndex={10}>
      <Flex align="center" justify="space-between">
        {/* Logo */}
        <Link to={"/"}>
          <Image src={LogoHustle} alt="Logo" width={{ base: "90px", md: "170px" }} />
        </Link>

        {/* Desktop Nav Links */}
        <HStack spacing={10} display={{ base: "none", md: "flex" }} fontWeight="medium">
          <Text
            cursor="pointer"
            _hover={{ color: "purple.100" }}
            onClick={() => handleScroll("features")}
          >
            Features
          </Text>
          <Text
            cursor="pointer"
            _hover={{ color: "purple.100" }}
            onClick={() => handleScroll("fitfor")}
          >
            Fit For
          </Text>
          <Text
            cursor="pointer"
            _hover={{ color: "purple.100" }}
            onClick={() => handleScroll("plans")}
          >
            Plans
          </Text>
        </HStack>

        {/* Login Button */}
        <Button
          display={{ base: "none", md: "inline-flex" }}
          bg={textColor}
          color="black"
          borderRadius="full"
          px={6}
          _hover={{ bg: "#ff7de9" }}
          _dark={{
            bg: textColor,
            color: "black",
            _hover: {
              bg: "#d6abcfff",
              color: "black",
            },
          }}
          onClick={() => navigate("/signIn")}
        >
          Login
        </Button>

        {/* Hamburger Icon */}
        <IconButton
          display={{ base: "inline-flex", md: "none" }}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          variant="ghost"
          aria-label="Toggle Navigation"
          onClick={onToggle}
        />
      </Flex>

      {/* Mobile Nav Links */}
      <Collapse in={isOpen} animateOpacity>
        <VStack align="start" spacing={4} mt={4} pl={2} display={{ md: "none" }}>
          <Text
            cursor="pointer"
            onClick={() => {
              onClose(); // close the Drawer first
              setTimeout(() => {
                document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
              }, 100); // wait for Drawer to close
            }}
          >
            Features
          </Text>
          <Text
            cursor="pointer"
            onClick={() => {
              onClose();
              setTimeout(() => {
                document.getElementById("fitfor")?.scrollIntoView({ behavior: "smooth" });
              }, 100);
            }}
          >
            Fit For
          </Text>
          <Text
            cursor="pointer"
            onClick={() => {
              onClose();
              setTimeout(() => {
                document.getElementById("plans")?.scrollIntoView({ behavior: "smooth" });
              }, 100);
            }}
          >
            Plans
          </Text>
          <Button
            size="sm"
            bg={textColor}
            color="black"
            borderRadius="full"
            px={6}
            _hover={{ bg: "#ff7de9" }}
            _dark={{
              bg: textColor,
              color: "black",
              _hover: {
                bg: "#d6abcfff",
                color: "black",
              },
            }}
            onClick={() => {
              navigate("/signIn");
              onToggle();
            }}
          >
            Login
          </Button>
        </VStack>
      </Collapse>
    </Box>
  );
}
